// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"19f889005897ddc03573","655":"45d5887867e99c1bdc9d"}[chunkId] + ".js";
};